import { jsx } from 'react/jsx-runtime';

const SIZE_MAP = {
  sm: '9',
  md: '14',
  lg: '14'
};
const ArrowIcon = ({
  className,
  fillColor,
  size = 'md'
}) => jsx("svg", Object.assign({
  height: SIZE_MAP[size],
  viewBox: "0 0 23 23",
  width: SIZE_MAP[size],
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: jsx("path", {
    className: className,
    d: "M12.002 15.38l9.589-9.588 1.414 1.414-11.003 11.002L1 7.206l1.414-1.414z",
    fill: fillColor
  }, void 0)
}), void 0);
ArrowIcon.displayName = 'ArrowIcon';

export { ArrowIcon };
